export default __webpack_public_path__ + "static/media/vertigo-horizontal-hendricks.83c2a694.png";